import React from 'react'
import { CopyIcon, HighlightedHashProps } from '@caudena/web-platform'
import { HighlightedHash, Icon } from '@caudena/core/ui-kit'
import capitalizeFirstLetter from '@caudena/core/utils/capitalizeFirstLetter'
import { Link } from '@caudena/core'
import { CurrencyValue } from '../../types/coin'
import { getCurrency } from '../../constants/currency'
import * as S from './TransactionHighlightedLink.styles'

interface TransactionHighlightedLinkProps {
  currency: CurrencyValue
  hash: string
  typographyVariant?: HighlightedHashProps['variant']
}

export const TransactionHighlightedLink = ({
  currency,
  hash,
  typographyVariant,
}: TransactionHighlightedLinkProps) => {
  const coin = getCurrency(currency)
  return (
    <S.HighlightedWrapper gap="md" align="center">
      <div>
        <Icon variant={capitalizeFirstLetter(coin)} />
      </div>
      <S.HighlightedWrapper align={'center'} gap={'xs'}>
        <S.HighlightedLinkWrapper>
          <Link
            to="%PLATFORM_URL%/:coin/explorer/transaction/:id"
            params={{
              id: hash,
              coin,
            }}
          >
            <HighlightedHash
              enabledCopy={false}
              variant={typographyVariant}
              hash={hash || ''}
            />
          </Link>
        </S.HighlightedLinkWrapper>
        <CopyIcon value={hash} />
      </S.HighlightedWrapper>
    </S.HighlightedWrapper>
  )
}
